import { render } from "./team-logo-vs.vue?vue&type=template&id=6131ddfe&scoped=true"
import script from "./team-logo-vs.vue?vue&type=script&lang=js"
export * from "./team-logo-vs.vue?vue&type=script&lang=js"

import "./team-logo-vs.vue?vue&type=style&index=0&id=6131ddfe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6131ddfe"]])

export default __exports__